import React from "react"
import Row from "../bootstrap/row"
import Col from "../bootstrap/col"
import Card from "../bootstrap/card"
import CardBody from "../bootstrap/card_body"
import CardFooter from "../bootstrap/card_footer"
import { cardHover } from "./annual-events.module.scss"
import ImageVid from "../shared/image-or-video"
import {Link} from "gatsby"
import { GetISODate } from "../../utils/utilities"
import moment from "moment"
import SocialMedia from "../shared/social-media"

const AnnualNews = props => {
 // const faculties = props.faculty
 // let image = {}
  return (
        <Row>
          {props.data.map(({ node }) => (
            <Col xs={11} md={6} xl={4} className="bg-gray-900 pb-4" key={node.id}>
              <Card as="article" className={`bg-gray-900 h-100 ${cardHover}`}>
                <div className="pb-3 card-image-top">
                  <ImageVid
                    alt={node.frontmatter.title + " news author"}
                    imagename={node.frontmatter.project_pic}
                    youtube={node.frontmatter.youtube_video}
                    vimeo={node.frontmatter.vimeo_video}
                  />
                </div>
                <CardBody className="h-100">
                  <Row>
                  </Row>
                  <h2 className="text-lights name headline h4">
                    <Link
                      to={`/${node.fields.slug.substring(1,node.fields.slug.length-1)}/`}
                      className="stretched-link text-light"
                    >
                      {node.frontmatter.title}
                    </Link>
                  </h2>

                  <p className="media-date h6 mb-0 text-light">
                    <time dateTime={GetISODate(node.frontmatter.date)}>
                      {moment
                        .parseZone(node.frontmatter.date)
                        .format(`MMM DD, YYYY`)}
                    </time>
                  </p>
                  <div className="post-content text-light mt-4">
                    {node.excerpt} 
                  </div>
                </CardBody>
                <CardFooter>
                  <SocialMedia
                    site={node.fields.slug.substring(1)}
                    title={node.frontmatter.title}
                  />
                </CardFooter>
              </Card>
            </Col>
          ))}
        </Row>
  )
}

export default AnnualNews
